import { ErrorHandler, Injectable, inject } from '@angular/core';
import { ChunkRecoveryService } from './chunk-recovery.service';

/**
 * Global {@link ErrorHandler} that intercepts lazy-chunk / dynamic-import load
 * failures thrown outside a router navigation (e.g. a deferred import) and routes
 * them to {@link ChunkRecoveryService} for a bounded reload. All other errors fall
 * through to the default console logging.
 */
@Injectable()
export class ChunkLoadErrorHandler implements ErrorHandler {
  /** Coordinator that decides whether/how to recover from a chunk-load failure. */
  private readonly recovery = inject(ChunkRecoveryService);

  /**
   * Handles an application error, recovering from chunk-load failures and logging
   * everything else.
   * @param error the error thrown anywhere in the application
   */
  public handleError(error: unknown): void {
    if (this.recovery.isChunkLoadError(error)) {
      this.recovery.recover();
      return;
    }
    console.error(error);
  }
}
